import '../Grid.less';
import React, { FC, ReactNode } from 'react';

interface IProps {
    children?: ReactNode;
}

const Grid: FC<IProps> = ({ children = null }) => <div className="grid">{children}</div>;

export default Grid;
